import React, { useContext } from "react";

import { Box, Typography, useTheme } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import CalorieFireIcon from "@components/Icons/CalorieFireIcon";

import FoodExchangeGuide from "./FoodExchangeGuide";
import MacronutrientsGuide from "./MacronutrientsGuide";
import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    border: "1px solid #EDF0F5",
    display: "flex",
  },
  icon: {
    fontSize: 64,
  },
  bold: {
    fontWeight: "bold",
  },
}));

const Header: React.FC = observer(() => {
  const theme = useTheme();
  const { classes } = useStyles();
  const store = useContext(MealPlanFormStore.Context);

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        alignItems="center"
        padding={theme.spacing(8, 2)}
        width="50%"
      >
        <CalorieFireIcon className={classes.icon} />
        <Box marginLeft={theme.spacing(1)} width="514px">
          <Typography color="textSecondary">
            Coach recommendation calories
          </Typography>
          <Typography variant="h4" className={classes.bold}>
            {Math.round(store.recommendedCaloriesKcal)} kcal
          </Typography>
          <MacronutrientsGuide />
        </Box>
      </Box>
      <FoodExchangeGuide />
    </div>
  );
});

export default Header;
